import type { PageKey } from "@owners/shared-types";
import { PAGE_LABELS } from "@owners/shared-types";
import { PHASE } from "../routes";

export function Placeholder({ page }: { page: PageKey }) {
  return (
    <>
      <div className="draft-note">DRAFTING NOTE: this page is scheduled for build phase {PHASE[page] ?? "TBD"} (PROPOSAL §9). Access to it is already enforced.</div>
      <h1>{PAGE_LABELS[page]}</h1>
      <div className="card muted">Coming soon.</div>
    </>
  );
}
